import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import VillePage from "@/pages/VillePage";

export const EASE = [0.16, 1, 0.3, 1];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const CHAPTERS = [
  {
    id: "01",
    kicker: "Salle de bain signature",
    title: "Le gris lustré, en toute maîtrise",
    description:
      "Céramique de douche gris lustré, bain autoportant sculptural, robinetterie murale noire et toilette intelligente. Le plancher de céramique blanc, souligné de rayures de gris, rencontre une vanité de quartz — le tout posé à la main par notre main-d'œuvre d'expertise.",
    bullets: [
      "Bain autoportant & robinetterie murale noire",
      "Toilette intelligente",
      "Plancher céramique blanc à rayures de gris",
      "Vanité quartz sur mesure",
    ],
    image: "/images/salle-de-bain-gris.png",
    alt: "Salle de bain haut de gamme avec douche en céramique gris lustré, bain autoportant et robinetterie noire",
  },
  {
    id: "02",
    kicker: "Douche à l'italienne",
    title: "Le bois naturel et le cuivre",
    description:
      "Une douche à l'italienne enveloppée de céramique couleur bois naturel, un plancher de céramique blanche rehaussé de cuivre et une vanité en bois naturel. Une atmosphère de spa, chaleureuse et intemporelle.",
    bullets: [
      "Douche à l'italienne sans seuil",
      "Céramique couleur bois naturel",
      "Plancher blanc aux accents de cuivre",
      "Vanité en bois naturel",
    ],
    image: "/images/salle-de-bain-bois.png",
    alt: "Salle de bain avec douche à l'italienne en céramique bois naturel et accents de cuivre",
  },
  {
    id: "03",
    kicker: "Salle de bain marbre",
    title: "Le quartz, le bois blanc et le marbre",
    description:
      "Quartz et bois blanc à l'effet marbre, une douche rehaussée de noir, une vanité de bois marbré et une toilette intelligente. Le plancher de bois résistant à l'eau, à l'effet bois de grange, réchauffe l'ensemble avec caractère.",
    bullets: [
      "Quartz & bois blanc effet marbre",
      "Douche aux accents noirs",
      "Vanité de bois marbré",
      "Toilette intelligente",
      "Plancher bois résistant à l'eau, effet bois de grange",
    ],
    image: "/images/salle-de-bain-quartz.png",
    alt: "Salle de bain en quartz et bois blanc effet marbre avec douche noire, vanité bois marbré et plancher bois de grange",
  },
];

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div
      className="grain bg-[#5b676f] text-[#F9F9F9] font-body overflow-x-clip"
      data-testid="app-root"
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/renovation-salle-de-bain/:slug"
            element={<VillePage />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#4d585f",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F9F9F9",
          },
        }}
      />
    </div>
  );
}

export default App;
